import { render, staticRenderFns } from "./ServiceManagement.vue?vue&type=template&id=6365af44&"
import script from "./ServiceManagement.js?vue&type=script&lang=js&"
export * from "./ServiceManagement.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports